import React from "react";
import DropdownTemplate, {
	DropDownItem,
} from "~/common/components/DropdownPortal/DropdownTemplate";
import { useTranslation } from "react-i18next";

const DropdownList = ({ target, modifyModalOpen, deleteModalOpen }) => {
	const { t } = useTranslation();
	return (
		<DropdownTemplate target={target} vertical>
			<DropDownItem
				onClick={() => {
					modifyModalOpen(target);
				}}
			>
				{t("common.commonWord.button.modify")}
			</DropDownItem>
			<DropDownItem
				onClick={() => {
					deleteModalOpen(target);
				}}
			>
				{t("common.commonWord.button.delete")}
			</DropDownItem>
		</DropdownTemplate>
	);
};

export default DropdownList;
